import { useIntlModule, formatIntlMessage, IntlModuleTypes } from '@enterprise/common';
import { MessageValue } from 'locale';
import { useIntl } from 'react-intl';
import messages from './notifications.intl.json';

export type NotificationIntlKey = IntlModuleTypes.IntlKeys<typeof messages>;
export type NotificationIntlMessages = ReturnType<typeof useNotificationsIntl>;
export type NotificationFormatFunction = ReturnType<typeof useFormatNotificationMessage>;

export function useNotificationsIntl() {
  return useIntlModule(messages);
}

export const useFormatNotificationMessage = () => {
  const intlShape = useIntl();
  return (message: NotificationIntlKey, variables?: Record<string, MessageValue>) =>
    formatIntlMessage(intlShape, messages, message, variables);
};
